// Junior Mathematics Unit Tests and Exercises - Years 7-10
// Based on Vanuatu National Syllabus

// Year 7 Mathematics Unit Tests
export const year7JuniorMathematicsUnitTests = {
  term1: {
    title: "Term 1 - Number & Algebra",
    tests: [
      {
        title: "Unit Test 1: Integers and Operations",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Short Answer", marks: 20, questions: 8 },
          { name: "Section C: Problem Solving", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Calculate: -8 + 5 - (-3)",
          "Evaluate using BODMAS: 24 ÷ 4 + 3 × 2",
          "Round 4.567 to 1 decimal place"
        ]
      },
      {
        title: "Unit Test 2: Fractions and Percentages",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Calculations", marks: 20, questions: 8 },
          { name: "Section C: Word Problems", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Convert 3/8 to a decimal and percentage",
          "Calculate: 2/5 + 3/4",
          "A shirt costs 850 VT. Find the price after a 15% discount."
        ]
      },
      {
        title: "Unit Test 3: Algebraic Expressions",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Simplification", marks: 20, questions: 8 },
          { name: "Section C: Substitution", marks: 10, questions: 3 }
        ],
        sampleQuestions: [
          "Simplify: 4x + 3y - 2x + 5y",
          "Expand: 5(2x - 3)",
          "If p = 4 and q = -2, find 3p - 2q"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Measurement & Geometry",
    tests: [
      {
        title: "Unit Test 4: Solving Equations",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Equation Solving", marks: 20, questions: 8 },
          { name: "Section C: Word Problems", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Solve: x - 7 = 15",
          "Solve: 4x + 5 = 21",
          "I think of a number, multiply by 3 and add 5. The answer is 26. Find the number."
        ]
      },
      {
        title: "Unit Test 5: Perimeter, Area and Volume",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Calculations", marks: 20, questions: 8 },
          { name: "Section C: Problem Solving", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Find the perimeter and area of a rectangle 8cm by 5cm",
          "Calculate the area of a triangle with base 12cm and height 7cm",
          "Find the volume of a cuboid 4cm × 5cm × 3cm"
        ]
      },
      {
        title: "Unit Test 6: Angles and Lines",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Angle Calculations", marks: 20, questions: 8 },
          { name: "Section C: Parallel Lines", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Find the missing angle if two angles on a straight line are 65° and x°",
          "Name the type of angle that measures 145°",
          "Find all angles when two parallel lines are cut by a transversal, given one angle is 72°"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Statistics & Review",
    tests: [
      {
        title: "Unit Test 7: Shapes and Transformations",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Shape Properties", marks: 20, questions: 8 },
          { name: "Section C: Transformations", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "How many lines of symmetry does a regular hexagon have?",
          "Describe the transformation that maps A to B",
          "Draw the reflection of shape P in the line y = x"
        ]
      },
      {
        title: "Unit Test 8: Probability",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Probability Calculations", marks: 20, questions: 8 },
          { name: "Section C: Combined Events", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "A bag contains 3 red, 5 blue and 2 green balls. Find P(red)",
          "What is the probability of rolling a prime number on a dice?",
          "List all outcomes when flipping two coins"
        ]
      },
      {
        title: "Unit Test 9: Data and Statistics",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Calculations", marks: 20, questions: 8 },
          { name: "Section C: Data Interpretation", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Find the mean, median, mode and range of: 4, 6, 3, 8, 6, 5, 6",
          "Calculate the mean from a frequency table",
          "Draw a pie chart to represent the given data"
        ]
      }
    ]
  }
};

// Year 8 Mathematics Unit Tests
export const year8JuniorMathematicsUnitTests = {
  term1: {
    title: "Term 1 - Number & Algebra",
    tests: [
      {
        title: "Unit Test 1: Indices and Standard Form",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Index Laws", marks: 20, questions: 8 },
          { name: "Section C: Standard Form", marks: 10, questions: 3 }
        ],
        sampleQuestions: [
          "Simplify: 3⁴ × 3²",
          "Write 0.00056 in standard form",
          "Calculate: (2.5 × 10³) × (4 × 10²)"
        ]
      },
      {
        title: "Unit Test 2: Expanding and Factorising",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Expanding", marks: 15, questions: 6 },
          { name: "Section C: Factorising", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Expand: (x + 4)(x - 2)",
          "Factorise: 12x - 8",
          "Factorise: x² + 5x + 6"
        ]
      },
      {
        title: "Unit Test 3: Equations and Inequalities",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Solving Equations", marks: 20, questions: 8 },
          { name: "Section C: Inequalities", marks: 10, questions: 3 }
        ],
        sampleQuestions: [
          "Solve: 3(2x - 1) = 15",
          "Solve: 5x + 2 > 3x + 10",
          "Represent x ≤ 3 on a number line"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Graphs & Measurement",
    tests: [
      {
        title: "Unit Test 4: Linear Graphs",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Graph Plotting", marks: 20, questions: 6 },
          { name: "Section C: Equation of Line", marks: 10, questions: 3 }
        ],
        sampleQuestions: [
          "Plot the graph of y = 2x - 3",
          "Find the gradient and y-intercept of 3x + 2y = 6",
          "Find the equation of the line through (1, 3) and (3, 7)"
        ]
      },
      {
        title: "Unit Test 5: Circles and Prisms",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Circle Calculations", marks: 15, questions: 6 },
          { name: "Section C: Volume", marks: 15, questions: 4 }
        ],
        sampleQuestions: [
          "Find the circumference of a circle with diameter 14cm",
          "Find the area of a circle with radius 6cm",
          "Find the volume of a cylinder with radius 5cm and height 12cm"
        ]
      },
      {
        title: "Unit Test 6: Pythagoras' Theorem",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Finding Sides", marks: 20, questions: 8 },
          { name: "Section C: Applications", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Find the hypotenuse if the other sides are 6cm and 8cm",
          "Find the missing side if the hypotenuse is 10cm and one side is 6cm",
          "A ladder 5m long leans against a wall. Its base is 2m from the wall. How high does it reach?"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Geometry & Statistics",
    tests: [
      {
        title: "Unit Test 7: Transformations",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Describing Transformations", marks: 20, questions: 6 },
          { name: "Section C: Combined Transformations", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the transformation that maps A to B",
          "Enlarge shape P by scale factor 2, centre (0, 0)",
          "Triangle ABC is reflected in line x = 2, then translated. Find the final position."
        ]
      },
      {
        title: "Unit Test 8: Combined Probability",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Tree Diagrams", marks: 20, questions: 5 },
          { name: "Section C: Applications", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Draw a tree diagram for tossing two coins",
          "Two dice are thrown. Find P(total = 7)",
          "A bag has 4 red and 6 blue balls. Two are picked with replacement. Find P(both red)."
        ]
      },
      {
        title: "Unit Test 9: Scatter Graphs",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Plotting and Correlation", marks: 20, questions: 6 },
          { name: "Section C: Interpretation", marks: 10, questions: 2 }
        ],
        sampleQuestions: [
          "Plot the scatter graph for the given data",
          "Describe the correlation shown in the scatter graph",
          "Draw a line of best fit and use it to estimate values"
        ]
      }
    ]
  }
};

// Year 9 Mathematics Unit Tests
export const year9JuniorMathematicsUnitTests = {
  term1: {
    title: "Term 1 - Number & Algebra",
    tests: [
      {
        title: "Unit Test 1: Index Laws and Scientific Notation",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Index Laws", marks: 15, questions: 6 },
          { name: "Section C: Scientific Notation", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Simplify: x^3 × x^5",
          "Evaluate: 2^(-3)",
          "Write 0.000347 in standard form",
          "Calculate (3 × 10^4) × (2 × 10^5) in standard form"
        ]
      },
      {
        title: "Unit Test 2: Fractions, Percentages and Proportion",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Fractions and Percentages", marks: 15, questions: 6 },
          { name: "Section C: Ratio and Proportion", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Convert 0.363636... to a fraction",
          "A shirt costs $45 after a 25% discount. Find the original price.",
          "y is directly proportional to x. When x = 4, y = 20. Find y when x = 7."
        ]
      },
      {
        title: "Unit Test 3: Expanding and Factorising",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Expanding Double Brackets", marks: 15, questions: 6 },
          { name: "Section C: Factorising Quadratics", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Expand: (x + 3)(x - 5)",
          "Factorise: x^2 - 7x + 12",
          "Factorise: x^2 - 49"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Equations, Coordinate Geometry & Measurement",
    tests: [
      {
        title: "Unit Test 4: Equations",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Quadratic Equations", marks: 15, questions: 5 },
          { name: "Section C: Simultaneous Equations", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Solve by factorising: x^2 - 7x + 12 = 0",
          "Use the quadratic formula to solve: 2x^2 + 3x - 5 = 0",
          "Solve: 2x + 3y = 7 and x + y = 3"
        ]
      },
      {
        title: "Unit Test 5: Coordinate Geometry and Sequences",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Lines and Gradients", marks: 20, questions: 7 },
          { name: "Section C: Sequences", marks: 10, questions: 4 }
        ],
        sampleQuestions: [
          "Find the gradient of the line through (2,3) and (6,11)",
          "Find the midpoint and distance between (1,4) and (5,8)",
          "Find the nth term of 3, 7, 13, 21, 31..."
        ]
      },
      {
        title: "Unit Test 6: Measurement",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Circles, Arcs and Sectors", marks: 15, questions: 5 },
          { name: "Section C: Surface Area and Volume", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Find the arc length of a sector with radius 8cm and angle 60 degrees",
          "Find the volume of a cone with radius 4cm and height 9cm",
          "Find the surface area of a sphere with radius 5cm"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Geometry, Probability & Statistics",
    tests: [
      {
        title: "Unit Test 7: Transformations",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Describing Transformations", marks: 15, questions: 5 },
          { name: "Section C: Enlargement and Combined", marks: 15, questions: 4 }
        ],
        sampleQuestions: [
          "Describe the single transformation that maps shape A to shape B",
          "Enlarge triangle T by scale factor -2 from centre (0,0)",
          "Describe fully the combined transformation"
        ]
      },
      {
        title: "Unit Test 8: Pythagoras and Trigonometry",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Pythagoras' Theorem", marks: 15, questions: 5 },
          { name: "Section C: Trigonometric Ratios", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Find the hypotenuse of a right triangle with sides 5cm and 12cm",
          "Find the opposite side if angle = 40 degrees and hypotenuse = 15cm",
          "Find the area of a triangle with sides 8cm and 10cm and included angle 50 degrees"
        ]
      },
      {
        title: "Unit Test 9: Probability and Data",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Probability (Venn/Tree Diagrams)", marks: 15, questions: 5 },
          { name: "Section C: Cumulative Frequency and Box Plots", marks: 15, questions: 4 }
        ],
        sampleQuestions: [
          "Use the Venn diagram to find P(A or B)",
          "Draw a tree diagram for picking 2 balls without replacement",
          "Draw a cumulative frequency curve and find the median and IQR"
        ]
      }
    ]
  },
  internalAssessment: {
    task1: {
      title: "Teacher Design Task 1 (TDT1)",
      weight: 15,
      description: "Mathematical investigation on Number or Algebra strand"
    },
    task2: {
      title: "Teacher Design Task 2 (TDT2)",
      weight: 15,
      description: "Mathematical investigation on Geometry or Measurement strand"
    },
    task3: {
      title: "Common Assessment Task (CAT)",
      weight: 10,
      description: "National common task covering all strands"
    }
  }
};

// Year 10 Mathematics Unit Tests
export const year10JuniorMathematicsUnitTests = {
  term1: {
    title: "Term 1 - Surds, Number & Algebra",
    tests: [
      {
        title: "Unit Test 1: Surds and Number",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Simplifying Surds", marks: 15, questions: 6 },
          { name: "Section C: Proportion and Multipliers", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Simplify: sqrt(72)",
          "Rationalise: 6/(sqrt(5) - 1)",
          "y is directly proportional to x^2. When x = 3, y = 36. Find y when x = 5.",
          "A car depreciates by 15% per year. If it costs $20,000, find its value after 3 years."
        ]
      },
      {
        title: "Unit Test 2: Quadratic Expressions and Proof",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Completing the Square and Fractions", marks: 20, questions: 8 },
          { name: "Section C: Algebraic Proof", marks: 10, questions: 3 }
        ],
        sampleQuestions: [
          "Complete the square for x^2 - 6x + 5",
          "Simplify: (x^2 - 9)/(x^2 - x - 6)",
          "Prove that the sum of three consecutive integers is always divisible by 3"
        ]
      },
      {
        title: "Unit Test 3: Equations and Formulae",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Quadratic Equations", marks: 15, questions: 5 },
          { name: "Section C: Change of Subject and Simultaneous", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Solve by completing the square: x^2 + 4x - 12 = 0",
          "Solve: y = x + 1 and y = x^2 - 3x + 5",
          "Make r the subject of V = (4/3)pi r^3"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Coordinate Geometry, Measurement & Geometry",
    tests: [
      {
        title: "Unit Test 4: Coordinate Geometry",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Lines and Inequalities", marks: 15, questions: 5 },
          { name: "Section C: Quadratic Graphs and Circles", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Find the equation of the line perpendicular to y = 2x + 1 through (4, 3)",
          "Shade the region satisfying y < 2x + 1 and y > -x + 3",
          "Sketch y = (x - 2)^2 + 3 showing the vertex",
          "Draw the graph of x^2 + y^2 = 25"
        ]
      },
      {
        title: "Unit Test 5: Measurement and Geometric Proof",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Volume and Surface Area", marks: 15, questions: 5 },
          { name: "Section C: Proof and Transformations", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Find the volume of a cone with radius 5cm and height 12cm",
          "A copra dryer is a rectangular prism 3m x 2m x 1.5m. Calculate its volume.",
          "Prove that the exterior angle of a triangle equals the sum of the two opposite interior angles",
          "Describe the single transformation that maps A to B"
        ]
      },
      {
        title: "Unit Test 6: Sequences",
        duration: "30 minutes",
        totalMarks: 25,
        sections: [
          { name: "Section A: Multiple Choice", marks: 5, questions: 5 },
          { name: "Section B: Arithmetic Sequences", marks: 20, questions: 6 }
        ],
        sampleQuestions: [
          "Find the 20th term of the sequence 5, 8, 11, 14, ...",
          "Prove that 2n + 3 is an arithmetic sequence",
          "A pattern uses 4 tiles for the 1st shape, 7 for the 2nd, 10 for the 3rd. How many for the 50th?"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Trigonometry, Probability & Statistics",
    tests: [
      {
        title: "Unit Test 7: Trigonometry (Sine & Cosine Rules)",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Right-angle Trigonometry and 3D", marks: 15, questions: 5 },
          { name: "Section C: Sine and Cosine Rules", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Find the angle of elevation from a point 30m from a building 20m tall",
          "Find side a using the sine rule: A = 50 degrees, B = 70 degrees, b = 12cm",
          "Find angle A using the cosine rule: a = 7, b = 8, c = 9"
        ]
      },
      {
        title: "Unit Test 8: Probability and Data",
        duration: "45 minutes",
        totalMarks: 40,
        sections: [
          { name: "Section A: Multiple Choice", marks: 10, questions: 10 },
          { name: "Section B: Probability with Set Notation", marks: 15, questions: 5 },
          { name: "Section C: Histograms and Standard Deviation", marks: 15, questions: 5 }
        ],
        sampleQuestions: [
          "Use set notation to find P(A union B)",
          "List the sample space for rolling two dice",
          "Calculate the standard deviation of: 5, 7, 8, 9, 11",
          "Construct a histogram from the frequency table with unequal class widths"
        ]
      },
      {
        title: "Unit Test 9: Comprehensive Review",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Number", marks: 8, questions: 4 },
          { name: "Section B: Algebra", marks: 20, questions: 8 },
          { name: "Section C: Measurement", marks: 8, questions: 3 },
          { name: "Section D: Geometry and Trigonometry", marks: 14, questions: 5 },
          { name: "Section E: Probability and Statistics", marks: 10, questions: 4 }
        ],
        sampleQuestions: [
          "Rationalise and simplify surd expressions",
          "Solve linear-quadratic simultaneous equations",
          "Apply sine rule and cosine rule to real-world problems",
          "Calculate standard deviation from grouped data"
        ]
      }
    ]
  },
  externalExamination: {
    title: "Year 10 National Examination",
    duration: "2 hours",
    totalMarks: 100,
    structure: [
      { section: "Section A: Multiple Choice", marks: 25, questions: 25 },
      { section: "Section B: Short Answer", marks: 35, questions: 15 },
      { section: "Section C: Extended Response", marks: 40, questions: 5 }
    ],
    strandWeighting: {
      number: "13%",
      algebra: "48%",
      measurement: "6%",
      geometry: "16%",
      probabilityStatistics: "17%"
    }
  }
};

export default {
  year7: year7JuniorMathematicsUnitTests,
  year8: year8JuniorMathematicsUnitTests,
  year9: year9JuniorMathematicsUnitTests,
  year10: year10JuniorMathematicsUnitTests
};
